// extracted by mini-css-extract-plugin
export default {"table":"commonTable_table__jXGcu","mobileCards":"commonTable_mobileCards__xrJ0s","mobileCard":"commonTable_mobileCard__5hCDM","cardRow":"commonTable_cardRow__Y1tfz"};